import { render, staticRenderFns } from "./unitEdit.vue?vue&type=template&id=455d3612"
import script from "./unitEdit.vue?vue&type=script&lang=js"
export * from "./unitEdit.vue?vue&type=script&lang=js"
import style0 from "./unitEdit.vue?vue&type=style&index=0&id=455d3612&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports